export default "__VITE_ASSET__C_8SCH3M__"